import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type Tone = 'neutral' | 'accent' | 'trusted' | 'check' | 'suspicious' | 'info' | 'muted';

const tones: Record<Tone, string> = {
  neutral: 'bg-surface-3 text-ink border-line',
  muted: 'bg-transparent text-ink-3 border-line',
  accent: 'bg-accent-soft text-accent-text border-transparent',
  trusted: 'bg-trusted-soft text-trusted border-trusted/30',
  check: 'bg-check-soft text-check border-check/30',
  suspicious: 'bg-suspicious-soft text-suspicious border-suspicious/30',
  info: 'bg-info-soft text-info border-info/30',
};

export function Badge({ tone = 'neutral', icon, children, className, title }: { tone?: Tone; icon?: ReactNode; children: ReactNode; className?: string; title?: string }) {
  return (
    <span
      title={title}
      className={cn(
        'inline-flex h-6 max-w-full items-center gap-1 whitespace-nowrap rounded-[3px] border px-1.5 text-xs font-medium [&>svg]:size-3.5 [&>svg]:shrink-0',
        tones[tone],
        className,
      )}
    >
      {icon}
      <span className="truncate">{children}</span>
    </span>
  );
}

/** Test case key, bug number etc. Always mono. */
export function Key({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={cn('mono whitespace-nowrap text-xs font-medium text-ink-2', className)}>{children}</span>;
}
